import { jsxs as e, jsx as C } from "react/jsx-runtime";
import { DEFAULT_METRIC_ICON_SIZE as i } from "./index.es2447.js";
function t({ size: l = i }) {
  return /* @__PURE__ */ e(
    "svg",
    {
      width: l,
      height: l,
      viewBox: "0 0 56 57",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ C("rect", { y: "0.936646", width: "56", height: "56", rx: "3", fill: "#F3F3FD" }),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M21.931 18.9366C16.4932 18.9366 12 23.3449 12 28.7828V29.0905C12 34.5284 16.4932 38.9366 21.931 38.9366C24.206 38.9366 26.3156 38.1651 28 36.8695C29.6844 38.1651 31.794 38.9366 34.069 38.9366C39.5069 38.9366 44 34.5284 44 29.0905V28.7828C44 23.3449 39.5069 18.9366 34.069 18.9366C31.794 18.9366 29.6844 19.7082 28 21.0038C26.3156 19.7082 24.206 18.9366 21.931 18.9366Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M28.0169 21.0061C30.3601 22.8076 31.8823 25.6212 31.8823 28.7828V29.0905C31.8823 32.2522 30.3601 35.0657 28.0169 36.8673C25.6737 35.0657 24.1514 32.2522 24.1514 29.0905V28.7828C24.1514 25.6212 25.6737 22.8076 28.0169 21.0061Z",
            fill: "#E1E2FF"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M21.931 18.9366C24.206 18.9366 26.3156 19.7082 28 21.0038C29.6844 19.7082 31.794 18.9366 34.069 18.9366C39.5069 18.9366 44 23.3449 44 28.7828V29.0905C44 34.5284 39.5069 38.9366 34.069 38.9366C31.794 38.9366 29.6844 38.1651 28 36.8695C26.3156 38.1651 24.206 38.9366 21.931 38.9366C16.4932 38.9366 12 34.5284 12 29.0905V28.7828C12 23.3449 16.4932 18.9366 21.931 18.9366ZM30.8621 29.0905V28.7828C30.8621 26.2354 29.7603 23.9346 28.0094 22.3184C26.2525 23.937 25.1515 26.2369 25.1515 28.7827V29.0904C25.1515 31.6363 26.2525 33.9362 28.0095 35.5548C29.7603 33.9386 30.8621 31.6378 30.8621 29.0905ZM24.1379 28.7828C24.1379 25.986 25.3265 23.4615 27.2209 21.6691C25.7357 20.581 23.9033 19.9366 21.931 19.9366C17.0342 19.9366 13 23.9083 13 28.7828V29.0905C13 33.965 17.0342 37.9366 21.931 37.9366C23.9033 37.9366 25.7357 37.2923 27.2209 36.2042C25.3265 34.4118 24.1379 31.8873 24.1379 29.0905V28.7828ZM28.7875 36.2104C30.2712 37.2948 32.1004 37.9366 34.069 37.9366C38.9658 37.9366 43 33.965 43 29.0905V28.7828C43 23.9083 38.9658 19.9366 34.069 19.9366C32.1004 19.9366 30.2713 20.5785 28.7876 21.6628C30.6884 23.4556 31.8824 25.9827 31.8824 28.7827V29.0904C31.8824 31.8905 30.6884 34.4176 28.7875 36.2104Z",
            fill: "#5E63E5"
          }
        )
      ]
    }
  );
}
t.__tags = [];
export {
  t as MetricOverlapIcon
};
//# sourceMappingURL=index.es417.js.map
